import React, { createContext, useState, useContext } from "react";
import { PaymentMethod } from "../models/payment";
import { Customer, CustomerWallet } from "../models/Service";

interface PaymentContextType {
  currentStep: number;
  customerUser: Customer | null;
  setCustomerUser: React.Dispatch<React.SetStateAction<Customer | null>>;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  amount: string;
  setAmount: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  selectedMethod: PaymentMethod | null;
  setSelectedMethod: React.Dispatch<React.SetStateAction<PaymentMethod | null>>;
  setSelectedWallet: React.Dispatch<
    React.SetStateAction<CustomerWallet | null>
  >;
  selectedWallet: CustomerWallet | null;
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  notificationNumber: string;
  setNotificationNumber: React.Dispatch<React.SetStateAction<string>>;
  error: string;
  setError: React.Dispatch<React.SetStateAction<string>>;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export const usePayment = () => {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error("usePayment must be used within a PaymentProvider");
  }
  return context;
};

export const PaymentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [customerUser, setCustomerUser] = useState<Customer | null>(null);
  const [selectedMethod, setSelectedMethod] = useState<PaymentMethod | null>(
    null
  );
  const [selectedWallet, setSelectedWallet] = useState<CustomerWallet | null>(
    null
  );
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [notificationNumber, setNotificationNumber] = useState("");

  return (
    <PaymentContext.Provider
      value={{
        customerUser,
        setCustomerUser,
        currentStep,
        setCurrentStep,
        amount,
        setAmount,
        name,
        setName,
        email,
        setEmail,
        selectedMethod,
        setSelectedMethod,
        phoneNumber,
        setPhoneNumber,
        notificationNumber,
        setNotificationNumber,
        error,
        setError,
        selectedWallet,
        setSelectedWallet,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};
